"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockTheme = mockTheme;
var fakeFunc = function (orientation) { return ''; };
function mockTheme(partial, variablesOverride) {
    if (partial === void 0) { partial = {}; }
    if (variablesOverride === void 0) { variablesOverride = {}; }
    var variables = partial.variables || {};
    var theme = {
        Colors: {
            primary: variables.primary,
            active: variables.active,
            inactive: variables.inactive,
            highlight: variables.active,
            selected: variables.selected,
            neutral: variables.lightBlueGrey,
            success: variables.success,
            success10: variables.success10,
            success100: variables.success100,
            success120: variables.success120,
            successLight: variables.green25,
            error100: variables.error100,
            error10: variables.error10,
            neutral20: variables.neutral20,
            neutral30: variables.neutral30,
            neutral120: variables.neutral120,
            warning: variables.warning,
            warningLight: variables.yellow25,
            danger: variables.danger,
            dangerLight: variables.red25,
            info: variables.info,
            link: variables.link,
            logo: variables.logo,
            dark: variables.dark,
            white: variables.white,
            secondary: variables.secondary,
            slateGrey: variables.slateGrey,
            Secondary: {
                main: variables.secondary,
                active: variables.secondaryActive,
                inactive: variables.secondaryInactive,
            },
            Backgrounds: {
                subtle: variables.subtle,
                web: variables.webGray,
                lighter: variables.veryLightBlue,
                lighter50: variables.veryLightBlue50,
                accent25: variables.paleBlue25,
                info25: variables.info25,
                toast: variables.toast,
                leftNavigation: variables.darkBlue,
                studentPlayer: variables.veryLightGray,
                recommendations: variables.recommendations,
            },
            Brand: {
                normal: variables.brand,
                active: variables.brandActive,
                inactive: variables.brandInactive,
                hover: variables.brandHover,
                disabled: variables.brandDisabled,
            },
            Indicator: {
                normal: variables.indicator,
                hover: variables.indicatorHover,
                light: variables.indicatorLight,
            },
            Shadows: {
                light: variables.charcoalGrey10,
            },
            Curriculum: {
                eureka: variables.eureka,
                eurekaMath: variables.eurekaMath,
                eurekaMath25: variables.eurekaMath25,
                eurekaAction: variables.eurekaAction,
                eurekaHover: variables.eurekaHover,
                eurekaActive: variables.eurekaActive,
                eurekaInactive: variables.eurekaInactive,
                eurekaDisabled: variables.eurekaDisabled,
                witAndWisdom: variables.witAndWisdom,
                witAndWisdom25: variables.witAndWisdom25,
                history: variables.history,
                em: {
                    main: variables.eurekaMath,
                    light: variables.eurekaLight,
                    action: variables.eurekaAction,
                    hover: variables.eurekaHover,
                    active: variables.eurekaActive,
                    inactive: variables.eurekaInactive,
                    disabled: variables.eurekaDisabled,
                    highlyProficient: variables.eurekaHighlyProficient,
                    proficient: variables.eurekaProficient,
                    partial: variables.eurekaPartial,
                    notYet: variables.eurekaNotYet,
                    none: variables.eurekaNone,
                    empty: variables.eurekaEmpty,
                },
                ww: {
                    main: variables.witAndWisdom,
                    light: variables.witAndWisdomLight,
                    action: variables.witAndWisdomAction,
                    hover: variables.witAndWisdomHover,
                    active: variables.witAndWisdomActive,
                    inactive: variables.witAndWisdomInactive,
                    disabled: variables.witAndWisdomDisabled,
                    bandA: variables.witAndWisdomBandA,
                    bandB: variables.witAndWisdomBandB,
                    bandC: variables.witAndWisdomBandC,
                    bandD: variables.witAndWisdomBandD,
                    bandE: variables.witAndWisdomBandE,
                },
                phd: {
                    main: variables.phdScience,
                    light: variables.phdScienceLight,
                    action: variables.phdSciencAction,
                    hover: variables.phdSciencHover,
                    active: variables.phdSciencActive,
                    inactive: variables.phdSciencInactive,
                    disabled: variables.phdSciencDisabled,
                },
                //geo was temporarily set to EM default values
                geo: {
                    main: variables.eurekaMath,
                    light: variables.eurekaLight,
                    action: variables.eurekaAction,
                    hover: variables.eurekaHover,
                    active: variables.eurekaActive,
                    inactive: variables.eurekaInactive,
                    disabled: variables.eurekaDisabled,
                    highlyProficient: variables.eurekaHighlyProficient,
                    proficient: variables.eurekaProficient,
                    partial: variables.eurekaPartial,
                    notYet: variables.eurekaNotYet,
                    none: variables.eurekaNone,
                    empty: variables.eurekaEmpty,
                },
            },
            Typography: {
                primary: variables.neoDark,
                secondary: variables.battleshipGrey,
                hint: variables.hint,
            },
            Borders: {
                hint: variables.hint,
                accent: variables.battleshipGrey,
                studentPlayer: variables.mediumGray,
            },
            Neo: {
                dark: variables.neoDark,
            },
        },
        Typography: {
            fontFamily: variables.fontFamilyBase,
            sansFontFamily: variables.fontFamilySans,
            quicksandFontFamily: variables.fontFamilyQuicksand,
            Sizes: {
                xs: variables.extraSmallFontSize,
                sm: variables.smallFontSize,
                smd: variables.smallMediumFontSize,
                md: variables.mediumFontSize,
                lg: variables.largeFontSize,
                xl: variables.extraLargeFontSize,
                xxl: variables.extraExtraLargeFontSize,
            },
            Weights: {
                normal: variables.normalWeight,
            },
        },
        Iconology: {
            Sizes: {
                sm: variables.smallIconSize,
                md: variables.mediumIconSize,
            },
        },
        Shadows: {
            modal: variables.modalShadow,
        },
        Spacing: {
            x1: variables.spx1,
            x2: variables.spx2,
            x3: variables.spx3,
            x4: variables.spx4,
            x5: variables.spx5,
            x6: variables.spx6,
            x7: variables.spx7,
        },
        Dimensions: {
            Borders: {
                default: variables.borderWidthx1,
                x1: variables.borderWidthx1,
                x2: variables.borderWidthx2,
                x3: variables.borderWidthx3,
                x4: variables.borderWidthx4,
                x5: variables.borderWidthx5,
                x6: variables.borderWidthx6,
                Radiuses: {
                    light: variables.lightBorderRadius,
                    medium: variables.mediumBorderRadius,
                    strong: variables.strongBorderRadius,
                    stronger: variables.strongerBorderRadius,
                    circle: variables.circleBorderRadius,
                },
            },
        },
        Textures: {
            Borders: {
                active: variables.solidBorderTexture,
            },
        },
        Utilities: {
            Flex: {
                center: fakeFunc,
            },
        },
    };
    return Object.assign(theme, partial);
}
